import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/chargeDataEnquiry/chargeDataSearch.scss';
import 'presentation/style/index.scss';
import { ProposalEnquiryDetailContainer } from 'presentation/view/container/ProposalEnquiry/ProposalEnquiryDetailContainer';

CommonEntrypoint(<ProposalEnquiryDetailContainer/>)